import script from "./Wellbeing.vue?vue&type=script&setup=true&lang=js"
export * from "./Wellbeing.vue?vue&type=script&setup=true&lang=js"

import "./Wellbeing.vue?vue&type=style&index=0&id=a27edd56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a27edd56"]])

export default __exports__